import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FarmersService } from '~/api/services/farmers/index'
import Dialog from '~/components/Dialog'
import notify from '~/components/Notify'
import { handleErrors } from '~/utils/helpers'

interface DeleteFarmerProps {
  handleClose: (submited?: boolean) => void
  deleteFarmerData: any
}

const DeleteFarmer: React.FC<DeleteFarmerProps> = (props) => {
  const { t } = useTranslation()
  const [loadingModalAction, setLoadingModalAction] = useState(false)
  const { handleClose, deleteFarmerData } = props

  async function handleDeleteFarmer() {
    setLoadingModalAction(true)
    try {
      await FarmersService.deleteFarmer(deleteFarmerData?.id)
      handleClose(true)
      notify(t('Successfully deleted farmer'), 'success')
    } catch (error) {
      handleErrors(error)
    }
    setLoadingModalAction(false)
  }

  const name = deleteFarmerData?.companyName || ''

  return <Dialog
    isDialogOpen={Boolean(deleteFarmerData)}
    textHeader={t('Delete farmer {{name}}', { name })}
    textClose={t('Close')}
    handleClose={() => handleClose()}
    textContent={t('Do you want to delete farmer {{name}}?', { name })}
    textSubmit={t('Delete')}
    type={'abort'}
    isLoading={loadingModalAction}
    disableSubmit={loadingModalAction}
    handleSubmit={() => handleDeleteFarmer()}
  />
}
export default DeleteFarmer